import { useEffect } from 'react';

import { useAppDispatch } from 'app/hooks';
import { extractStatusCode } from 'common/services/api/apiHelpers';
import { fetchUserGroups } from 'common/services/api/UserGroups/UserGroups.thunk';
import { UserGroup } from 'common/types/Entities';
import { handleListFetchError } from 'common/utils/errorHandlers';
import { clearUserGroups } from 'features/userGroups/userGroupsSlice';
import { useSnackbar } from 'notistack';

type onChangeHandler = (userGroups: UserGroup[]) => void;

export const useFetchUserGroupsByTenantId = (onChange: onChangeHandler, tenantId: string) => {
    const dispatch = useAppDispatch();

    const { enqueueSnackbar } = useSnackbar();
    useEffect(() => {
        if(tenantId) {
            dispatch(fetchUserGroups({ tenantId }))
                .unwrap()
                .catch(error => {
                    dispatch(clearUserGroups());
                    onChange([]);
                    handleListFetchError(extractStatusCode(error.message), 'User Group', enqueueSnackbar);
                });

        } else {
            dispatch(clearUserGroups());
            onChange([]);
        }
    }, [tenantId]);
};
